//本人証明用ページURLと確認用パスワード発行 /personIdentification1/
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user'
import {Link,browserHistory} from 'react-router'
import './css/personIdentification1.css';
//import firebase from 'firebase'
import {onLogin, getCertificationCodes, registCertificationCode/*, deleteCertificationCode*/} from './firebase'

//ユーザランク取得処理
import {
  getUserRank
} from './functions/getUserRank'
import {IsLoading} from './loading';

export default class App extends Component {

  constructor() {
    super();
    this.state = {
      displayName: "",
      photoURL: "",
      canvasImg:"",

      code:"",
      uid:"",

      rank:"",
      rank_img:"",
      rank_class:"",
      rank_jp:"",
      rank_class_jp:"",
      rank_chart:"",
      yahoo_auction:[],
      coconala:[],
      anyca:[],
      notteco:[],
      spacemarket:[]
    };
  }

  componentDidMount() {
    var scope = this
    
    // ログインチェック
    onLogin(function(){

      var uid = users.getMyUser().uid
      scope.setState({uid: uid});

      // ユーザーのプロフィール取得
      //ユーザー情報取得APIをたたく（非ログインユーザー用）
      let getUserData = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              let res = JSON.parse(xhr.response)
              getUserRank(uid, scope, false, res)
              scope.setState({displayName: res.displayName});
              scope.setState({photoURL: res.updatePhoto ? res.updatePhoto : "https://graph.facebook.com/" + res.facebookId + "/picture?width=250&height=250"});
            }
          }
        }
        xhr.open('POST','/api/getUser')
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send(JSON.stringify({uid:uid}))
      }
      //非ログインユーザーはDBに直接アクセス権がないのでAPIを叩く
      getUserData(uid)
    });
  }

  createIdentification(e){
    var scope = this

    // 認証用URL取得
    getCertificationCodes(this.state.uid, function(value){

      // 期間内のURL取得
      var certifications = {}
      var cd = new Date(); 
      var datetime = cd.getFullYear() + "-" + ("0"+(cd.getMonth()+1)).slice(-2)  + "-" + ("0"+cd.getDate()).slice(-2) + " " + ("0"+cd.getHours()).slice(-2) + ":" + ("0"+cd.getMinutes()).slice(-2) + ":" + ("0"+cd.getSeconds()).slice(-2);
      var now = new Date(datetime);
      var cid = 1;
      for (var n in value) {
        var targetDate = new Date(value[n].created_at);
        var diff = (now.getTime() - targetDate.getTime()) / (1000 * 60 * 60);
        // 期間=24時間以内(23時間59分59秒99まで)
        if (24 > diff) {
          certifications[value[n].id] = n;
        }
        cid++;
      }

      // 認証番号ランダム生成
      var code = Math.random().toString(36).slice(-6);

      //console.log({cid: cid, created_at: datetime, code: code})

      // DB保存
      registCertificationCode(scope.state.uid, {cid: cid, created_at: datetime, code: code});

      // 遷移
      browserHistory.push("/personIdentification/" + cid);
    });
  }
  isLoading = () => {
    const {
      rank_chart,
      photoURL,
      displayName
    } = this.state
    if(rank_chart && photoURL) {
      return (
        <div className="block-thum clearfix">
          <img className="user-chart" src={rank_chart} alt="" />
          <img className="user-thum" src={photoURL} alt="" />
          <p className="text-center user-name">{displayName}</p>
          <p className="text-center user-address">Japan</p>
        </div>
      )
    } else {
      return IsLoading()
    }
  }

render(){
  return (
    <div>
      <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-personIdentification1">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <h2 className="title">Personal Identification</h2>
                <p className="subtitle">本人証明をしよう！</p>
                { this.isLoading() }
                <p className="text-notification">発行する本人証明用ページURLと確認用パスワードを相手に伝えて、MyRateの情報が自分本人のものであることを証明しましょう。</p>
              </div>
              <div className="block-notification">
                <p>※確認用パスワードは発行してから24時間有効です</p>
                <p>※共有したい相手が複数人いる場合は、人数分都度発行してください。</p>
              </div>
              <Link className="btn-register" onClick={(e) => {this.createIdentification(e)}}>URLとパスワードを発行する</Link>

            </div>
            <Footer/>
            <div className="cardCover white-cover">
          </div>
          </div>
        </div>
      </div>
    </div>
      </div>
  )
}

}



// WEBPACK FOOTER //
// ./src/personIdentification1.js